/**
 * PGSS-5738: MUI hands renderOption a props object that includes the option's React `key`. Spreading that object
 * into JSX makes React warn ("A props object containing a "key" prop is being spread into JSX"), and React 19
 * stops accepting it. Pass the key directly and spread the rest:
 *
 *   renderOption={(props, option) => <li key={optionKey(props)} {...withoutKey(props)}>…</li>}
 */
export function optionKey(props) {
  return props?.key;
}

export function withoutKey(props) {
  if (!props || typeof props !== 'object') return props;
  const { key, ...rest } = props;
  return rest;
}
